import { Component } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import shallowCompare from 'react-addons-shallow-compare';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import EditFormControl from 'ContentComponents/components/cmv2/EditFormControl';
import { Small } from 'foundations-components/transitional/components/Small';
import ImagePreview from 'ContentComponents/components/cmv2/fields/ImagePreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.cta.${key}`;
const buttonI18nKey = suffix => `ContentComponents.buttons.${suffix}`;
class CtaBase extends Component {
  constructor(props) {
    super(props);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  get isInvalidCta() {
    const {
      hasLoaded,
      selectedCtaImage,
      value
    } = this.props;
    return hasLoaded && !selectedCtaImage && value;
  }
  onEdit() {
    const {
      onOpenEditor = emptyFunction
    } = this.props;
    onOpenEditor();
  }
  onDelete() {
    const {
      onFieldChange = emptyFunction
    } = this.props;
    onFieldChange('');
  }
  renderInvalidCta() {
    const {
      hasCtaAccess = false,
      onOpenPicker = emptyFunction,
      readOnly = false
    } = this.props;
    const isDisabled = readOnly || !hasCtaAccess;
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "cmv2-cta-invalid",
      children: /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        children: /*#__PURE__*/_jsxs(ButtonWrapper, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('invalidCtaSelected')
          }), /*#__PURE__*/_jsx(Button, {
            "data-test-id": "cmv2-cta-replace-button",
            disabled: isDisabled,
            onClick: onOpenPicker,
            size: "extra-small",
            use: "tertiary",
            children: /*#__PURE__*/_jsx(Small, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: buttonI18nKey('replace')
              })
            })
          }), /*#__PURE__*/_jsx(Button, {
            "data-test-id": "cmv2-cta-remove-button",
            disabled: isDisabled,
            onClick: this.onDelete,
            size: "extra-small",
            use: "tertiary-light",
            children: /*#__PURE__*/_jsx(Small, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: buttonI18nKey('remove')
              })
            })
          })]
        })
      })
    });
  }
  renderImage() {
    const {
      selectedCtaImage
    } = this.props;
    const {
      altText,
      url
    } = selectedCtaImage || {};
    return selectedCtaImage ? /*#__PURE__*/_jsx(ImagePreview, {
      alt: altText,
      src: url
    }) : null;
  }
  renderReplaceButton() {
    const {
      hasCtaAccess = false,
      onOpenPicker = emptyFunction,
      readOnly = false,
      value = null
    } = this.props;
    const isDisabled = !value || readOnly || !hasCtaAccess;
    if (!value || this.isInvalidCta) {
      return null;
    }
    return /*#__PURE__*/_jsx(Button, {
      "data-test-id": "cmv2-cta-replace-button",
      disabled: isDisabled,
      onClick: onOpenPicker,
      use: "link",
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: buttonI18nKey('replace')
        })
      })
    });
  }
  renderAddButton() {
    const {
      hasCtaAccess = false,
      onOpenPicker = emptyFunction,
      readOnly = false,
      value = null
    } = this.props;
    const isDisabled = readOnly || !hasCtaAccess;
    if (value) {
      return null;
    }
    return /*#__PURE__*/_jsx(Button, {
      "data-test-id": "cmv2-cta-add-button",
      disabled: isDisabled,
      onClick: onOpenPicker,
      size: "small",
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('insertCta')
      })
    });
  }
  renderRemoveButton(disableOnMissing = false) {
    const {
      hasCtaAccess = false,
      readOnly = false,
      required,
      value = null
    } = this.props;
    const isDisabled = readOnly || Boolean(required && value && hasCtaAccess);
    if (!disableOnMissing && !value) {
      return null;
    }
    return /*#__PURE__*/_jsx(Button, {
      "data-test-id": "cmv2-cta-remove-button",
      disabled: isDisabled,
      onClick: this.onDelete,
      use: "link",
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: buttonI18nKey('remove')
        })
      })
    });
  }
  renderEditButton(disableOnMissing = false) {
    const {
      disableEdit = false,
      editTooltip,
      hasCtaAccess = false,
      readOnly = false,
      value = null
    } = this.props;
    const isDisabled = readOnly || !value || disableEdit || !hasCtaAccess;
    if (!disableOnMissing && !value) {
      return null;
    }
    let editButton = /*#__PURE__*/_jsx(Button, {
      "data-test-id": "cmv2-cta-edit-button",
      disabled: isDisabled,
      onClick: this.onEdit,
      size: "extra-small",
      use: "tertiary-light",
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('editCta')
        })
      })
    });
    if (editTooltip) {
      editButton = /*#__PURE__*/_jsx(Tooltip, {
        title: editTooltip,
        children: editButton
      });
    }
    return editButton;
  }
  render() {
    const {
      label = '',
      hasLoaded = false,
      help_text: helpText,
      inline_help_text: inlineHelpText,
      required,
      value = null
    } = this.props;
    return /*#__PURE__*/_jsx(EditFormControl, {
      helpText: helpText,
      inlineHelpText: inlineHelpText,
      label: label,
      labelItemRight: hasLoaded && /*#__PURE__*/_jsxs("div", {
        children: [this.renderReplaceButton(), this.renderRemoveButton()]
      }),
      required: required,
      children: !hasLoaded ? /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered",
        grow: true
      }) : this.isInvalidCta ? this.renderInvalidCta() : /*#__PURE__*/_jsxs("div", {
        children: [this.renderImage(), value ? this.renderEditButton() : this.renderAddButton()]
      })
    });
  }
}
export default CtaBase;